// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  RolePropagationAction,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  scheduledId: __t.u64().name("scheduled_id"),
  get action() {
    return RolePropagationAction;
  },
  databaseName: __t.string().name("database_name"),
  targetIdentityHex: __t.string().name("target_identity_hex"),
  roleName: __t.string().name("role_name"),
  projectId: __t.u32().name("project_id"),
  success: __t.bool(),
  errorMessage: __t.option(__t.string()).name("error_message"),
  httpStatus: __t.option(__t.u16()).name("http_status"),
  executedAt: __t.timestamp().name("executed_at"),
  scope: __t.option(__t.string()),
});
